module.exports = __webpack_public_path__ + "static/s1-bg-864e87ee687abe13366183eb0a4cb802.png";